module.exports = __webpack_public_path__ + "static/media/mobile-promo-high.882c24fa.png";